// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-list-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.no-records-found {
  text-align: center;
  font-size: 1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

.filter-one-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.filter-one-row input {
  width: 49%;
}

.select-all-container {
  margin-top: 10px;
  margin-left: auto;
  display: flex;
  align-items: center;
}
.select-all-container label {
  margin-left: 5px;
  font-size: 15px;
}

.cases-options {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
}
.cases-options .manage-cases-btn,
.cases-options .assign-cases-btn {
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
}
.cases-options .lawyer-select-container {
  position: relative;
}
.cases-options .lawyer-select-container .select-lawyer-btn {
  padding: 8px 18px;
  background: var(--success-color);
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
}
.cases-options .lawyer-select-container .select-lawyer-btn:active {
  transform: scale(0.98);
}
.cases-options .lawyer-select-container .lawyer-dropdown {
  position: fixed; /* Changed from absolute to fixed like filter dropdown */
  /* top and left will be set dynamically via inline styles */
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  min-width: 320px;
  max-width: 400px;
  z-index: 1000;
  max-height: 500px;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
  margin-left: 44px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-search-input {
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  background: #fafafa;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-search-input::placeholder {
  color: #9ca3af;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-search-input:focus {
  border-bottom-color: #3b82f6;
  background: white;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options {
  max-height: 180px;
  overflow-y: auto;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.15s ease;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option:hover {
  background: #f8fafc;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option.focused {
  background: #dbeafe;
  border-left: 3px solid #3b82f6;
  padding-left: 13px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option:last-child {
  border-bottom: none;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option input[type=checkbox] {
  margin-right: 12px;
  transform: scale(1.1);
  cursor: pointer;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option .lawyer-name {
  font-size: 14px;
  font-weight: 500;
  margin-right: 8px;
  color: #1f2937;
  flex: 1 1;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options .lawyer-option .lawyer-email {
  color: #6b7280;
  font-size: 12px;
  font-style: italic;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar {
  width: 6px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .lawyer-options::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers h4 {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #374151;
  font-weight: 600;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list {
  max-height: 80px;
  overflow-y: auto;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar {
  width: 4px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyer-tag {
  display: inline-flex;
  align-items: center;
  background: #dbeafe;
  color: #1e40af;
  padding: 4px 10px;
  border-radius: 16px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #bfdbfe;
  animation: tagAppear 0.2s ease-out;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyer-tag button {
  background: none;
  border: none;
  color: #1e40af;
  margin-left: 6px;
  cursor: pointer;
  padding: 0 2px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  line-height: 1;
}
.cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyer-tag button:hover {
  background: #1e40af;
  color: white;
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn {
  width: 100%;
  padding: 8px 18px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn:active:not(:disabled) {
  transform: translateY(0);
}
.cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.filter-tab .filter-dropdown-box .filter-group {
  gap: 5px;
}
.filter-tab .main-case-filter-dropdown-box .main-case-filter-filter-group {
  width: 49%;
}
.filter-tab .filter-dropdown-box {
  min-width: 320px;
  max-width: 400px;
}
.filter-tab .filter-dropdown-box.customer-filters {
  min-width: 280px;
  max-width: 350px;
}
.filter-tab .filter-dropdown-box.customer-filters .page-filter .main-case-filter-filter-group {
  width: 100%;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes tagAppear {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
.hammer-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hammer-loader .hammer {
  font-size: 40px;
  margin-bottom: 16px;
  animation: hammer 1s ease-in-out infinite;
  transform-origin: bottom center;
}
.hammer-loader .anvil {
  font-size: 24px;
  margin-bottom: 16px;
  animation: anvil-shake 1s ease-in-out infinite;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 10px;
}
.pagination-controls button {
  padding: 6px 12px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-width: 80px;
  text-align: center;
}
.pagination-controls button:disabled {
  background: var(--primary-color);
  cursor: not-allowed;
  opacity: 0.6;
}

.page-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}

.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}
.pagination-settings #casesPerPageSelect {
  border: none !important;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #casesPerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #casesPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #casesPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

.filter-group .radio-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.radio-option {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.radio-option input[type=radio] {
  margin-right: 6px;
}

@keyframes hammer {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-45deg);
  }
  50% {
    transform: rotate(-90deg);
  }
  75% {
    transform: rotate(-45deg);
  }
}
@keyframes anvil-shake {
  0%, 100% {
    transform: translateX(0);
  }
  25%, 75% {
    transform: translateX(-2px);
  }
  50% {
    transform: translateX(2px);
  }
}
@media (max-width: 768px) {
  .cases-options {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .cases-options .lawyer-select-container .lawyer-dropdown {
    left: 50%;
    transform: translateX(-50%);
    min-width: 280px;
    max-width: 90vw;
  }
  .cases-options .lawyer-select-container .lawyer-dropdown .selected-lawyers .selected-lawyers-list {
    max-height: 60px;
  }
  .cases-options .lawyer-select-container .lawyer-dropdown .assign-action .assign-cases-final-btn {
    font-size: 13px;
    padding: 8px 12px;
  }
  .page-filter {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .pagination-settings {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CaseList/CaseList.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAGA;EACE,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EAEA,yCAAA;EACA,iBAAA;AADF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAFF;AAKE;EACE,UAAA;AAHJ;;AAQA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AALF;AAQE;EACE,gBAAA;EACA,eAAA;AANJ;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AARF;AAWE;;EAEE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AATJ;AAkBE;EACE,kBAAA;AAhBJ;AAmBI;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjBN;AAyBM;EACE,sBAAA;AAvBR;AA4BI;EACE,eAAA,EAAA,wDAAA;EACA,2DAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,iBAAA;AA1BN;AA6BM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA3BR;AA8BQ;EACE,cAAA;AA5BV;AAgCQ;EACE,4BAAA;EACA,iBAAA;AA9BV;AAmCM;EACE,iBAAA;EACA,gBAAA;AAjCR;AAoCQ;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;AAlCV;AAqCU;EACE,mBAAA;AAnCZ;AAsCU;EACE,mBAAA;EACA,8BAAA;EACA,kBAAA;AApCZ;AAwCU;EACE,mBAAA;AAtCZ;AA0CU;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;AAxCZ;AA4CU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AA1CZ;AA8CU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AA5CZ;AAkDQ;EACE,UAAA;AAhDV;AAoDQ;EACE,mBAAA;AAlDV;AAsDQ;EACE,mBAAA;EACA,kBAAA;AApDV;AAwDQ;EACE,mBAAA;AAtDV;AA2DM;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;AAzDR;AA8DQ;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA5DV;AAgEQ;EACE,gBAAA;EACA,gBAAA;AA9DV;AAkEU;EACE,UAAA;AAhEZ;AAoEU;EACE,mBAAA;EACA,kBAAA;AAlEZ;AAsEU;EACE,mBAAA;EACA,kBAAA;AApEZ;AAwEU;EACE,mBAAA;AAtEZ;AA2EQ;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kCAAA;AAzEV;AA4EU;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,cAAA;AA1EZ;AA6EY;EACE,mBAAA;EACA,YAAA;AA3Ed;AAkFM;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;AAhFR;AAmFQ;EACE,WAAA;EACA,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAjFV;AA2FU;EACE,wBAAA;AAzFZ;AA6FU;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA3FZ;;AAqGE;EACE,QAAA;AAlGJ;AAsGE;EACE,UAAA;AApGJ;AAwGE;EACE,gBAAA;EACA,gBAAA;AAtGJ;AAyGI;EACE,gBAAA;EACA,gBAAA;AAvGN;AA0GQ;EACE,WAAA;AAxGV;;AAyKA;EACE;IACE,UAAA;IACA,wCAAA;EAtKF;EA0KA;IACE,UAAA;IACA,iCAAA;EAxKF;AACF;AA4KA;EACE;IACE,UAAA;IACA,qBAAA;EA1KF;EA8KA;IACE,UAAA;IACA,mBAAA;EA5KF;AACF;AAgLA;EAGE;IAEE,YAAA;EAjLF;EAqLA;IACE,UAAA;EAnLF;AACF;AAuLA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AArLF;AAwLE;EACE,eAAA;EACA,mBAAA;EACA,yCAAA;EACA,+BAAA;AAtLJ;AA0LE;EACE,eAAA;EACA,mBAAA;EACA,8CAAA;AAxLJ;;AA6LA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AA1LF;AA6LE;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AA3LJ;AA8LI;EACE,gCAAA;EACA,mBAAA;EACA,YAAA;AA5LN;;AAkMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AA/LF;;AAmMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAhMF;AAmME;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjMJ;AAqME;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AAzMJ;AA4MI;EACE,yBAAA;AA1MN;AA8MI;EACE,wDAAA;EACA,uBAAA;AA5MN;AAgNI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AA9MN;;AAoNA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAjNF;;AAqNA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAlNF;;AAsNA;EACE,iBAAA;AAnNF;;AAuNA;EAGE;IAEE,uBAAA;EAvNF;EA2NA;IACE,yBAAA;EAzNF;EA6NA;IACE,yBAAA;EA3NF;EA+NA;IACE,yBAAA;EA7NF;AACF;AAiOA;EAGE;IAEE,wBAAA;EAlOF;EAsOA;IAEE,2BAAA;EArOF;EAyOA;IACE,0BAAA;EAvOF;AACF;AA4OA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,QAAA;EA1OF;EA8OI;IACE,SAAA;IACA,2BAAA;IACA,gBAAA;IACA,eAAA;EA5ON;EAgPQ;IACE,gBAAA;EA9OV;EAoPQ;IACE,eAAA;IACA,iBAAA;EAlPV;EA0PA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAxPF;EA4PA;IACE,uBAAA;EA1PF;AACF","sourcesContent":[".case-list-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n\n.no-records-found {\n  text-align: center;\n  font-size: 1rem;\n  color: var(--text-color-medium);\n  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\n  background: var(--card-bg);\n  border-radius: 0.75rem;\n  border: 1px dashed var(--border-color);\n  // box-shadow: 0 2px 5px var(--shadow-light);\n  margin-top: calc(var(--spacing-unit) * 2);\n  grid-column: 1 / -1;\n}\n\n\n.filter-one-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n\n  input {\n    width: 49%;\n  }\n}\n\n\n.select-all-container {\n  margin-top: 10px;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n\n\n  label {\n    margin-left: 5px;\n    font-size: 15px;\n  }\n}\n\n\n.cases-options {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  flex-wrap: wrap;\n\n\n  .manage-cases-btn,\n  .assign-cases-btn {\n    padding: 8px 18px;\n    background: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 0.5rem;\n    cursor: pointer;\n\n\n    // &:hover {\n    //   opacity: 0.9;\n    // }\n  }\n\n\n  .lawyer-select-container {\n    position: relative;\n\n\n    .select-lawyer-btn {\n      padding: 8px 18px;\n      background: var(--success-color);\n      color: white;\n      border: none;\n      border-radius: 0.5rem;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n\n\n      // &:hover {\n      //   background: #15803d;\n      // }\n\n\n      &:active {\n        transform: scale(0.98);\n      }\n    }\n\n\n    .lawyer-dropdown {\n      position: fixed; /* Changed from absolute to fixed like filter dropdown */\n      /* top and left will be set dynamically via inline styles */\n      background: white;\n      border: 1px solid #d1d5db;\n      border-radius: 8px;\n      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n      min-width: 320px;\n      max-width: 400px;\n      z-index: 1000;\n      max-height: 500px;\n      overflow: hidden;\n      animation: slideDown 0.2s ease-out;\n      margin-left: 44px;\n\n\n      .lawyer-search-input {\n        width: 100%;\n        padding: 12px 16px;\n        border: none;\n        border-bottom: 1px solid #e5e7eb;\n        font-size: 14px;\n        outline: none;\n        box-sizing: border-box;\n        background: #fafafa;\n\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n\n\n        &:focus {\n          border-bottom-color: #3b82f6;\n          background: white;\n        }\n      }\n\n\n      .lawyer-options {\n        max-height: 180px;\n        overflow-y: auto;\n\n\n        .lawyer-option {\n          display: flex;\n          align-items: center;\n          padding: 12px 16px;\n          cursor: pointer;\n          border-bottom: 1px solid #f3f4f6;\n          transition: all 0.15s ease;\n\n\n          &:hover {\n            background: #f8fafc;\n          }\n\n          &.focused {\n            background: #dbeafe;\n            border-left: 3px solid #3b82f6;\n            padding-left: 13px;\n          }\n\n\n          &:last-child {\n            border-bottom: none;\n          }\n\n\n          input[type=\"checkbox\"] {\n            margin-right: 12px;\n            transform: scale(1.1);\n            cursor: pointer;\n          }\n\n\n          .lawyer-name {\n            font-size: 14px;\n            font-weight: 500;\n            margin-right: 8px;\n            color: #1f2937;\n            flex: 1;\n          }\n\n\n          .lawyer-email {\n            color: #6b7280;\n            font-size: 12px;\n            font-style: italic;\n          }\n        }\n\n\n        // Custom scrollbar\n        &::-webkit-scrollbar {\n          width: 6px;\n        }\n\n\n        &::-webkit-scrollbar-track {\n          background: #f1f1f1;\n        }\n\n\n        &::-webkit-scrollbar-thumb {\n          background: #c1c1c1;\n          border-radius: 3px;\n        }\n\n\n        &::-webkit-scrollbar-thumb:hover {\n          background: #a8a8a8;\n        }\n      }\n\n\n      .selected-lawyers {\n        padding: 12px 16px;\n        border-top: 1px solid #e5e7eb;\n        background: #f9fafb;\n        // max-height: 120px;\n        // overflow-y: auto;\n\n\n        h4 {\n          margin: 0 0 10px 0;\n          font-size: 13px;\n          color: #374151;\n          font-weight: 600;\n        }\n\n\n        .selected-lawyers-list {\n          max-height: 80px;\n          overflow-y: auto;\n\n\n          // Custom scrollbar for selected lawyers list\n          &::-webkit-scrollbar {\n            width: 4px;\n          }\n\n\n          &::-webkit-scrollbar-track {\n            background: #f1f1f1;\n            border-radius: 2px;\n          }\n\n\n          &::-webkit-scrollbar-thumb {\n            background: #c1c1c1;\n            border-radius: 2px;\n          }\n\n\n          &::-webkit-scrollbar-thumb:hover {\n            background: #a8a8a8;\n          }\n        }\n\n\n        .selected-lawyer-tag {\n          display: inline-flex;\n          align-items: center;\n          background: #dbeafe;\n          color: #1e40af;\n          padding: 4px 10px;\n          border-radius: 16px;\n          margin: 2px 4px 2px 0;\n          font-size: 12px;\n          font-weight: 500;\n          border: 1px solid #bfdbfe;\n          animation: tagAppear 0.2s ease-out;\n\n\n          button {\n            background: none;\n            border: none;\n            color: #1e40af;\n            margin-left: 6px;\n            cursor: pointer;\n            padding: 0 2px;\n            font-size: 14px;\n            font-weight: bold;\n            border-radius: 50%;\n            width: 16px;\n            height: 16px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            transition: all 0.15s ease;\n            line-height: 1;\n\n\n            &:hover {\n              background: #1e40af;\n              color: white;\n            }\n          }\n        }\n      }\n\n\n      .assign-action {\n        padding: 12px 16px;\n        border-top: 1px solid #e5e7eb;\n        background: #ffffff;\n\n\n        .assign-cases-final-btn {\n          width: 100%;\n          padding: 8px 18px;\n          background: var(--primary-color);\n          color: white;\n          border: none;\n          border-radius: 6px;\n          font-size: 14px;\n          font-weight: 600;\n          cursor: pointer;\n          transition: all 0.2s ease;\n\n\n          // &:hover:not(:disabled) {\n          //   background: #2563eb;\n          //   transform: translateY(-1px);\n          //   box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);\n          // }\n\n\n          &:active:not(:disabled) {\n            transform: translateY(0);\n          }\n\n\n          &:disabled {\n            background: #9ca3af;\n            cursor: not-allowed;\n            transform: none;\n            box-shadow: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n.filter-tab {\n  .filter-dropdown-box .filter-group {\n    gap: 5px;\n  }\n\n\n  .main-case-filter-dropdown-box .main-case-filter-filter-group {\n    width: 49%;\n  }\n\n  // Adjustments for customer role with fewer filter options\n  .filter-dropdown-box {\n    min-width: 320px;\n    max-width: 400px;\n    \n    // When there are fewer filters (customer role), adjust the layout\n    &.customer-filters {\n      min-width: 280px;\n      max-width: 350px;\n      \n      .page-filter {\n        .main-case-filter-filter-group {\n          width: 100%; // Full width for single status filter\n          //margin-bottom: 10px;\n        }\n      }\n    }\n  }\n\n  // .main-case-filter-dropdown-box {\n  //   // Better spacing for date filters\n  //   .filter-group {\n  //     //margin-bottom: 15px;\n      \n  //     &:last-child {\n  //       //margin-bottom: 10px;\n  //     }\n      \n  //     label {\n  //       display: block;\n  //       margin-bottom: 8px;\n  //       font-weight: 500;\n  //       color: #374151;\n  //       font-size: 14px;\n  //     }\n      \n  //     select {\n  //       width: 100%;\n  //       padding: 8px 12px;\n  //       border: 1px solid #d1d5db;\n  //       border-radius: 6px;\n  //       font-size: 14px;\n  //       background-color: white;\n  //       cursor: pointer;\n        \n  //       &:focus {\n  //         outline: none;\n  //         border-color: #3b82f6;\n  //         box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  //       }\n  //     }\n  //   }\n    \n  //   // Date filter styling\n  //   .filter-one-row {\n  //     display: flex;\n  //     gap: 10px;\n  //     align-items: center;\n      \n  //     input[type=\"date\"] {\n  //       flex: 1;\n  //       padding: 8px 12px;\n  //       border: 1px solid #d1d5db;\n  //       border-radius: 6px;\n  //       font-size: 14px;\n        \n  //       &:focus {\n  //         outline: none;\n  //         border-color: #3b82f6;\n  //         box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  //       }\n  //     }\n  //   }\n  // }\n}\n\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.95);\n  }\n\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n\n@keyframes tagAppear {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n\n@keyframes pulse {\n\n\n  0%,\n  100% {\n    opacity: 0.6;\n  }\n\n\n  50% {\n    opacity: 1;\n  }\n}\n\n\n.hammer-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n\n  .hammer {\n    font-size: 40px;\n    margin-bottom: 16px;\n    animation: hammer 1s ease-in-out infinite;\n    transform-origin: bottom center;\n  }\n\n\n  .anvil {\n    font-size: 24px;\n    margin-bottom: 16px;\n    animation: anvil-shake 1s ease-in-out infinite;\n  }\n}\n\n\n.pagination-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 20px 0;\n  gap: 10px;\n\n\n  button {\n    padding: 6px 12px;\n    background: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    min-width: 80px;\n    text-align: center;\n\n\n    &:disabled {\n      background: var(--primary-color);\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n}\n\n\n.page-filter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 5px;\n}\n\n\n.pagination-settings {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 7px 18px;\n  background-color: #E2E8F0;\n  border-radius: 6px;\n\n\n  label {\n    white-space: nowrap;\n    color: #1f2937;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n\n  #casesPerPageSelect {\n    border: none !important;\n    border-radius: 6px;\n    outline: none;\n    padding: 6px 32px 6px 12px;\n    background-color: white;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n    min-width: 70px;\n\n\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n\n\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    background-size: 16px;\n\n\n    transition: all 0.2s ease;\n    box-shadow: none !important;\n\n\n    &:hover {\n      background-color: #fafafa;\n    }\n\n\n    &:focus {\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n      background-color: white;\n    }\n\n\n    option {\n      border: none !important;\n      outline: none;\n      padding: 4px 8px;\n    }\n  }\n}\n\n\n.filter-group .radio-group {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #333;\n}\n\n\n.radio-option input[type=\"radio\"] {\n  margin-right: 6px;\n}\n\n\n@keyframes hammer {\n\n\n  0%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n\n  25% {\n    transform: rotate(-45deg);\n  }\n\n\n  50% {\n    transform: rotate(-90deg);\n  }\n\n\n  75% {\n    transform: rotate(-45deg);\n  }\n}\n\n\n@keyframes anvil-shake {\n\n\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n\n\n  25%,\n  75% {\n    transform: translateX(-2px);\n  }\n\n\n  50% {\n    transform: translateX(2px);\n  }\n}\n\n\n// Mobile responsiveness\n@media (max-width: 768px) {\n  .cases-options {\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n\n\n    .lawyer-select-container {\n      .lawyer-dropdown {\n        left: 50%;\n        transform: translateX(-50%);\n        min-width: 280px;\n        max-width: 90vw;\n\n\n        .selected-lawyers {\n          .selected-lawyers-list {\n            max-height: 60px;\n          }\n        }\n\n\n        .assign-action {\n          .assign-cases-final-btn {\n            font-size: 13px;\n            padding: 8px 12px;\n          }\n        }\n      }\n    }\n  }\n\n\n  .page-filter {\n    flex-direction: column;\n    gap: 10px;\n    align-items: stretch;\n  }\n\n\n  .pagination-settings {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
